export function formatMoney(currency: string, amount: number | string | null | undefined): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(amount || 0))
}

const THOUSAND = 1_000
const MILLION = 1_000_000
const BILLION = 1_000_000_000

// UAE business convention — abbreviate large amounts by 3-digit groups:
// thousands → "k", millions → "m", billions → "bn", always to two decimals.
const COMPACT_TIERS: { threshold: number; divisor: number; suffix: string }[] = [
  { threshold: BILLION, divisor: BILLION, suffix: 'bn' },
  { threshold: MILLION, divisor: MILLION, suffix: 'm' },
  { threshold: THOUSAND, divisor: THOUSAND, suffix: 'k' },
]

/**
 * Compact currency in the UAE business style — "AED 25.00k", "AED 2.50m",
 * "AED 2.50bn" — always to two decimals. Amounts below 1,000 render in full
 * ("AED 250.00"). For exact ledger values (transactions, wallet balances)
 * use {@link formatMoney} instead — this form trades precision for scannability.
 */
export function formatCompactMoney(
  currency: string,
  amount: number | string | null | undefined,
): string {
  const value = Number(amount ?? 0)
  if (!Number.isFinite(value)) return `${currency} 0.00`

  const abs = Math.abs(value)
  const sign = value < 0 ? '-' : ''
  const tier = COMPACT_TIERS.find((t) => abs >= t.threshold)
  const scaled = tier ? abs / tier.divisor : abs
  const suffix = tier?.suffix ?? ''

  return `${currency} ${sign}${scaled.toFixed(2)}${suffix}`
}
